import { OrderDirection } from '~api/som_search';

import { InteractiveTable, PageTitle, PageWrapper, PaginationProvider } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { useDebounce } from '~src/lib/hooks/useDebounce';
import { usePagination } from '~src/main/hooks/usePagination';

import { useTransportOrdersListQuery } from '../queries';
import { Filters } from './filters/filters';
import { useOrderListFilter } from './filters/useOrderListFilter';
import { ListTable } from './list-table';
import { ListTableBar } from './list-table-bar';

export function Page() {
  const { search } = useOrderListFilter();

  const { pageIndex, pageSize, direction, setPageSize, setPageIndex } = usePagination();
  const { t } = useTranslation();

  const { data, isFetched, isFetching } = useTransportOrdersListQuery({
    order_by_direction: direction.toUpperCase() as OrderDirection,
    'filtering.id': useDebounce(search, 300),
    pageIndex: pageIndex - 1,
    pageSize: pageSize,
  });

  return (
    <InteractiveTable.Provider allowHighlight keepInactive>
      <PaginationProvider
        onPageSizeChange={setPageSize}
        onPageNoChange={setPageIndex}
        pageSize={pageSize}
        pageNo={pageIndex}
      >
        <PageWrapper>
          <PageTitle.Title>{t('transportOrders.list.title')}</PageTitle.Title>

          <Filters />

          <section style={{ backgroundColor: 'inherit' }}>
            <ListTableBar />

            <ListTable
              isEmpty={isFetched && !data?.orders?.length}
              transportOrders={data?.orders ?? []}
              loadRowCount={pageSize}
              isLoading={isFetching}
            />
          </section>
        </PageWrapper>
      </PaginationProvider>
    </InteractiveTable.Provider>
  );
}
